import { IApplicationState } from '../../types/redux';

export const animationCounterSelector = (state: IApplicationState): number => {
  return state.consultantCianChat.animationCounter;
};
